module.exports = __webpack_public_path__ + "img/decorator-drums.c648fc82.png";